import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { useAbp } from 'core/hooks/useAbp';
import { GenericLoading } from 'components/ui/Loader';

interface PermissionGuardProps {
  policy?: string;
  policies?: readonly string[] | string[];
  requireAll?: boolean;
  fallback?: string;
  fallbackComponent?: ReactNode;
  requiresAuth?: boolean;
  children: ReactNode;
}

export const BoPermissionGuard = ({
  requiresAuth = true,
  children
}: PermissionGuardProps) => {
  const auth = useAuth();
  const { isAdmin, initialized, connectedUserInfos, loadingUserInfos } = useAbp();
  const location = useLocation();

  // Attendre que ABP soit initialisé
  if (!initialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <GenericLoading loading isParentSized />
          <p className="text-sm text-gray-600">Chargement des permissions...</p>
        </div>
      </div>
    );
  }

  // Vérification de l'authentification avec react-oidc-context
  if (requiresAuth && !auth.isAuthenticated) {
    // Sauvegarder la route courante pour redirection après login
    sessionStorage.setItem('redirectUrl', location.pathname + location.search);
    // Déclencher la connexion OIDC
    auth.signinRedirect();
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <GenericLoading loading isParentSized />
          <p className="text-sm text-gray-600">Redirection vers la connexion...</p>
        </div>
      </div>
    );
  }

  // Une fois le chargement terminé : si on a les infos user et qu'il n'est pas admin,
  // on bloque l'accès aux routes back-office (redirect 404).
  if (!loadingUserInfos && connectedUserInfos && !isAdmin) {
    return <Navigate to={'/404'} replace />;
  }


  return <>{children}</>;
};

